<template lang="pug">
.alpha
  //bw-hero
  bw-wavey-bottom
  bw-alpha
</template>

<script>
//import BwHero from "@/components/chunks/BwHero2";
import BwWaveyBottom from "@/components/shared/BwWaveyBottom";
import BwAlpha from "@/components/chunks/BwAlpha";
export default {
  components: {
    //BwHero,
    BwWaveyBottom,
    BwAlpha
  }
};
</script>

<style lang="stylus" scoped>
h1
  font-size: 40px
  text-align: center
  padding: 30px 0 0
  color: rgba(0,0,0,0.89)
h2
  font-size: 22px
  text-align: center
  font-weight: 300
.alpha
  padding-top: 250px
</style>
